var map = {
	"./electrodeio/default-messages": 60
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 142;


//////////////////
// WEBPACK FOOTER
// ./src/lang/tenants ^\.\/.*\/default\-messages$
// module id = 142
// module chunks = 0